import * as R from 'ramda'

export const calculateTotalValue = participant =>
  R.isEmpty(R.pathOr([], ['addons'], participant))
    ? R.path(['special'], participant)
      ? R.path(['race_detail', 'special_price'], participant)
      : R.path(['race_detail', 'price'], participant)
    : (
        parseFloat(
          R.path(['special'], participant)
            ? R.pathOr(0, ['race_detail', 'special_price'], participant)
            : R.pathOr(0, ['race_detail', 'price'], participant)
        ) +
        parseFloat(R.sum(R.map(R.path(['addon', 'price']), participant.addons)))
      ).toFixed(2)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Payment/utils.js